module.exports = __webpack_public_path__ + "img/bracelet.65263c22.png";